/**
 * @file   src\mobile\components\DeleteWantAdModal.js
 * @brief  This file is responsible for delete want ad confirmation modal
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { Modal } from "react-bootstrap";

const DeleteWantAdModal = (props) => {
  const { show, handleConfirm, onHide } = props;
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modalPopupstyle delete-popup"
    >
      <Modal.Body className="text-center">
        <h3>Are you sure you want to permanently delete your want-ad?</h3>
        <p>
          Deleting this ad will stop any further introductions from being sent
          to you.
        </p>
        <div className="btn-wrap">
          <button
            type="button"
            className="btn btn-delete w-100"
            onClick={handleConfirm}
          >
            Confirm
          </button>
          <button
            type="button"
            className="btn btn-secondary w-100"
            onClick={onHide}
          >
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default DeleteWantAdModal;
